export const MODOS_DASHBOARD = {
    ESFINGE_DIRETO: "e-Sfinge direto",
    FORNECEDOR: "Fornecedor",
    DESABILITADO: "Entrega desabilitada"
};

export function modoAtivoDashboard(configuracao) {
    if (!configuracao) return undefined;
    if (configuracao.enabled === false) return "DESABILITADO";
    return MODOS_DASHBOARD[configuracao.destino]
        ? configuracao.destino
        : undefined;
}

export function criterioDashboard(destino) {
    if (destino === "FORNECEDOR")
        return "Reserva, recebimento pelo fornecedor e aceite oficial do TCE-MS são etapas distintas. Somente o aceite oficial válido compõe as conclusões, os registros confirmados e os valores das folhas aceitas.";
    if (destino === "DESABILITADO")
        return "Entrega desabilitada: esta consulta mostra apenas as ocorrências registradas nesse modo. Não representa transmissão ao fornecedor ou ao TCE-MS.";
    return "Envio direto ao e-Sfinge: canceladas permanecem no histórico e não compõem conclusões vigentes, registros processados ou valores. Solicitações de cancelamento são acompanhadas na lista de ocorrências.";
}

export const APRESENTACAO_FORNECEDOR = {
    AGUARDANDO_APROVACAO: ["fact_check", "info"],
    EM_FILA: ["schedule", "primary"],
    AGUARDANDO_CONSUMO: ["outbox", "info"],
    AGUARDANDO_ANTECEDENTES: ["account_tree", "warning"],
    RESERVADA: ["bookmark_border", "info"],
    RESERVA_EXPIRADA: ["timer_off", "warning"],
    ENTREGA_EM_ANDAMENTO: ["sync", "info"],
    RECEBIDO_PELO_FORNECEDOR: ["inventory_2", "info"],
    ACEITO_TCE_MS: ["verified", "success"],
    REJEITADA: ["error_outline", "error"],
    FALHA_ENTREGA: ["error_outline", "error"],
    PROCESSADO_COM_ERRO: ["error_outline", "error"],
    RESULTADO_INDETERMINADO: ["report_problem", "warning"],
    A_CONFERIR: ["help_outline", "warning"]
};

export function indicadoresFornecedor(dados) {
    const principais = [
        "AGUARDANDO_CONSUMO",
        "AGUARDANDO_ANTECEDENTES",
        "RESERVADA",
        "RECEBIDO_PELO_FORNECEDOR",
        "ACEITO_TCE_MS"
    ];
    return (dados?.fornecedor?.situacoes || [])
        .filter(
            (item) => item.quantidade > 0 || principais.includes(item.chave)
        )
        .map((item) => {
            const [icone, cor] = APRESENTACAO_FORNECEDOR[item.chave] || [
                "help_outline",
                "warning"
            ];
            return {...item, icone, cor: `${cor}.main`};
        });
}

export function campoSerieDestino(destino) {
    return destino === "FORNECEDOR"
        ? "fornecedor"
        : destino === "ESFINGE_DIRETO"
        ? "esfingeDireto"
        : "outros";
}
